import axios from "axios";
import actions from "./actions";
import { getFilterUrlPart, parseUnitMapping } from "../../lib/utils";
import _ from "lodash";

const fetchScatterPlots = (id, options) => (dispatch, getState) => {

  dispatch(actions.fetchScatterPlotsStart());
  const { units, token, survey, actualSurvey } = options;
  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch((err) => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchScatterPlotsError(err));
      }
    });
  }
  function getScatterPlot(url) {
    return retryOnFail(function () {
      return axios.get(url);
    });
  }
  const promises = [];
  const filterParams = getFilterUrlPart(getState().filters);

  const isPulse = survey && survey.indexOf("Pulse") > -1;
  let comparativeDatasets;
  if (options.comparativeDatasets) {
    comparativeDatasets = options.comparativeDatasets
      ? options.comparativeDatasets.split("||").map((str) => str.split("|"))
      : [];
  } else {
    comparativeDatasets = [["", "this"]];
  }

  let parsedMapping = parseUnitMapping(options.comparativeUnitMappings);

  comparativeDatasets.forEach((dataset) => {
    const datasetId = dataset[1] === "this" ? id : dataset[1];

    //find the prior mapped unit values for this dataset
    const unitsParam = _.map(units, unit => {
      if (!parsedMapping) return unit;

      const mapping = parsedMapping[unit];
      if (!mapping) return unit;

      const mappedUnit = mapping[dataset[0]];
      if (!mappedUnit) return unit;

      return mappedUnit;
    })
    .map(unit => `'${encodeURIComponent(unit)}'`)
    .join(',')

    let type = "DEFAULT";
    if (isPulse) {
      if (/SUTTER_Pulse/.test(actualSurvey)) {
        type = "SUTTER_PULSE";
      } else if (/PENN.*_Pulse_2020/.test(actualSurvey)) {
        type = "PENN_2020_PULSE";
      } else if (/STANFORD_Pulse_2021/.test(actualSurvey)) {
        type = "STANFORD_Pulse_2021";
      } else if (/SRH_Pulse_2022/.test(actualSurvey) || /SRH_Pulse_2022a/.test(actualSurvey)) {
        type = "SRH_Pulse_2022";
      } else if (/VIZ_BNCHMRK_Pulse_2022/.test(actualSurvey)) {
        type = "VIZ_BNCHMRK_Pulse_2022";
      } else if (/RISE_Pulse_2023/.test(actualSurvey)) {
        type = "RISE_Pulse_2023";
      } else if (/QUEENS_Pulse_2023/.test(actualSurvey)) {
        type = "QUEENS_Pulse_2023";
      } else {
        type = "PULSE";
      }
    } else if (/TRINITY/.test(actualSurvey)) {
      type = "TRINITY";
    } else if (/NHSOPS/.test(actualSurvey)) {
      type = "NHSOPS";
    } else if (/MOSOPS/.test(actualSurvey)) {
      type = "MOSOPS";
    } else if (/HSOPS/.test(actualSurvey)) {
      type = "HSOPS";
    } else if (/ASC_SOPS_2023/.test(actualSurvey)) {
      type = "ASC_SOPS_2023";
    }

    let axisVariables = [];

    const { scatterplots } = options.configuration;
    if (scatterplots && scatterplots.axisVariables && Array.isArray(scatterplots.axisVariables)) {
        axisVariables = scatterplots.axisVariables.map(v => v.endpoint);
    } else {
      switch (type) {
        case "SUTTER_PULSE":
          axisVariables.push(
            "questionX/scorle/leinput/questionY/scorpsy/psyposfb"
          );
          axisVariables.push(
            "questionX/scorsafclim/cultlearn/questionY/scorsafclim/feelsafe"
          );
          break;
        case "PENN_2020_PULSE":
          axisVariables.push(
            "questionX/scorle/lefixdefct/questionY/scorpsy/psyposfb"
          );
          axisVariables.push(
            "questionX/scorsafclim/spkupclt/questionY/scorsafclim/feelsafe"
          );
          break;
        case "STANFORD_Pulse_2021":
          axisVariables.push(
            "questionX/scorsafclim/safeacted/questionY/scortmclim/spkupclt"
          );
          axisVariables.push(
            "questionX/scorsafclim/diffdiscuss/questionY/scorsafclim/comdelay"
          );
          break;
        case "RISE_Pulse_2023":
          axisVariables.push(
            "questionX/scorsafclim/safeacted/questionY/scortmclim/spkupclt"
          );
          axisVariables.push(
            "questionX/scorsafclim/diffdiscuss/questionY/scorsafclim/comdelay"
          );
          break;
        case "VIZ_BNCHMRK_Pulse_2022":
          axisVariables.push(
            "questionX/scorsafclim/safeacted/questionY/scortmclim/spkupclt"
          );
          axisVariables.push(
            "questionX/scorsafclim/diffdiscuss/questionY/scorsafclim/comdelay"
          );
          break;
        case "SRH_Pulse_2022":
          axisVariables.push(
            "questionX/scorsafclim/benefit_self/questionY/scorsafclim/feeling_optimistic"
          );
          axisVariables.push(
            "questionX/scorsafclim/benefit_org/questionY/scorsafclim/feeling_supported"
          );
          break;
          case "QUEENS_Pulse_2023":
            axisVariables.push(
              "questionX/scorsafclim/easyask/questionY/scorsafclim/cultlearn"
            );
            axisVariables.push(
              "questionX/scorsafclim/safeacted/questionY/scortmclim/spkupclt"
            );
            break;
        case "PULSE":
          axisVariables.push(
            "questionX/scorle/leinput/questionY/scorpsy/psyposfb"
          );
          if (actualSurvey !== "USC_KECK_Pulse_2022") {
            axisVariables.push(
              "questionX/scorsafclim/cultlearn/questionY/scorpsy/psyuseflfb"
            );
          }
          break;
        case "TRINITY":
          axisVariables.push("domainX/scortmclim/null/domainY/scorsafclim/null");
          axisVariables.push("domainX/scorpsy/null/domainY/scoreeclm/null");
          break;
        case "HSOPS":
          axisVariables.push(
            "questionX/hsops_team/busy_staff_helps,problem_disrespect,work_together/questionY/hsops_rpt/caught_corrected_reported,could_harm_mistakes"
          );
          axisVariables.push(
            "questionX/hsops_err/informed_changes,informed_errors,discuss_prevention/questionY/hsops_ps/adequat_resources,ps_after_event,ps_top_priority"
          );
          break;
        case "MOSOPS":
          axisVariables.push(
            "questionX/mosops_team/busy_othr_help,treat_respect,emph_teamwork/questionY/mosops_perc/chance_more_mistakes,mistakes_happen,prevent_mistakes,work_over_quality"
          );
          axisVariables.push(
            "questionX/mosops_err/report_mistakes,prevent_errors,staff_mistakes_held,staff_talk_openly_probs/questionY/mosops_ps/dec_best_pats,improve_procs,invest_resources,overlook_mistakes"
          );
          break;
        case "NHSOPS":
          axisVariables.push(
            "questionX/nhsops_team/treat_with_respect,staff_support_staff,staff_part_of_team/questionY/nhsops_perc/patients_cared_for,good_job_keep_safe,safe_for_patients"
          );
          axisVariables.push(
            "questionX/nhsops_feed/staff_report_harm,discuss_incidents,report_potential_harm,discuss_safety/questionY/nhsops_mgmt/mgmt_asks_improve_ps,mgmt_listens_staff_ideas,mgmt_checks_on_care,mistakes_get_repeated"
          );
          break;
          case "ASC_SOPS_2023":
            axisVariables.push(
              "questionX/ascsops_team/others_help_out,understand_each_roles,work_together_team,disrespectful_behavior/questionY/ascsops_open/authority_speak_up,doesnt_seem_right,ideas_valued_facility"
            );
            axisVariables.push(
              "questionX/ascsops_org_learn/actively_improve_ps,improv_ps_problems,change_process_ps/questionY/ascsops_mgmt/mngr_encourage_improv,mgnt_examine_near_miss,mgnt_adeq_resources"
            );
            break;
        case "DEFAULT":
        default:
          axisVariables.push("domainX/scortmclim/null/domainY/scorsafclim/null");
          axisVariables.push("domainX/scorle/null/domainY/scorpsy/null");
      }
    }
    axisVariables.forEach((axisVariables) => {
      promises.push(
        getScatterPlot(
          `/api/survey/${datasetId}/scatterplot/${axisVariables}/by/unit?units=&positions=&optimized=null&token=${token}${filterParams}`
        )
      );
      promises.push(
        getScatterPlot(
          `/api/survey/${datasetId}/scatterplot/${axisVariables}/by/position?units=${unitsParam}&positions=&optimized=null&token=${token}${filterParams}`
        )
      );
    });
  });

  Promise.all(promises).then((results) => {
    const scatterplots = [];
    for (let i = 0; i < results.length; i++) {
      const scatterplotsIndex =
        i % (results.length / comparativeDatasets.length);
      const comparativeDatasetIndex = Math.floor(
        i / (results.length / comparativeDatasets.length)
      );
      const year = comparativeDatasets[comparativeDatasetIndex][0];
      const scatterplotData = { data: results[i].data, year };
      if (scatterplots.length <= scatterplotsIndex) {
        scatterplots.push([scatterplotData]);
      } else {
        scatterplots[scatterplotsIndex].push(scatterplotData);
      }
    }
    dispatch(actions.fetchScatterPlots(scatterplots));
  });
};

const clearProgress = () => (dispatch, getState) => {
  dispatch(actions.fetchScatterPlotsStart());
};

export default {
  fetchScatterPlots,
  clearProgress,
};


// WEBPACK FOOTER //
// ./src/redux/scatterPlots/operations.js